import { DangerousHtmlContent, Notification, variants } from '@eti/components';
import { useProperty, useTranslation } from '@eti/providers';
import { isRyanAirLccSupplierForTrip } from '../../utils/carriers';
import type { BoundsType } from '../../models';

const getNotificationContent = (text: string, linkLabel: string) =>
  text.replace(
    '{RAVF}',
    `<a href="javascript:void();" data-ryanairverificationprocesslink>${linkLabel}</a>`,
  );

interface RyanAirVerificationProcessNotificationProps {
  bounds: BoundsType;
}

const RyanAirVerificationProcessNotification = ({
  bounds,
}: RyanAirVerificationProcessNotificationProps) => {
  const { p } = useProperty();
  const { t } = useTranslation();

  const isEnabled = p('Payment.RyanairVerificationProcess.Enabled');
  const content = getNotificationContent(
    t('PaymentPage.RyanairVerificationProcess.Info.Text'),
    t('PaymentPage.RyanairVerificationProcess.Info.Anchor.Text'),
  );

  return isEnabled && isRyanAirLccSupplierForTrip(bounds) ? (
    <Notification
      dataTestId="paymentPage-ryanAirVerificationNotification"
      title={t('PaymentPage.RyanairVerificationProcess.Info.Title')}
      variant={variants.INFORMATION}
    >
      <DangerousHtmlContent content={content} />
    </Notification>
  ) : null;
};

export default RyanAirVerificationProcessNotification;
